import { CustomButton, IconButton } from '@/components/buttons/Buttons';
import { showNotification } from '@/modules/notification/engine/notification.library';
import { useNavigate, useParams } from 'react-router-dom';
import { MdArrowBack } from 'react-icons/md';
import EmployeeActivities from '../components/employee/EmployeeActivities';
import EmployeeDetails from '../components/employee/EmployeeDetails';
import style from './employee.module.css';
import './people.styles.css';
import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '@/services/axios.service';
import { GenericResponse } from '@/common/common_utils';
import { ENDPOINTS } from '@/constants/endpoints';
import { BaseResponse, X4bEmployeeDetailsDto } from '@/types';
import NiceModal from '@ebay/nice-modal-react';
import ConfirmModal from '../components/ConfirmModal';
import { useAuthenticationStore } from '@/store';
import { X4bUserRoleEnum } from '@/constants/roles';

type Ride = {
	service?: string;
	average?: number;
	total?: string;
	time?: string;
};

type Send = {
	service?: string | null;
	average?: number | null;
	total?: string | null;
	time?: string | null;
};

type Eats = {
	product?: string | null;
	store?: string | null;
	total?: string | null;
	time?: string | null;
};

type Mart = {
	product?: string | null;
	store?: string | null;
	total?: string | null;
	day?: string | null;
};

type Insights = {
	lastLogin: string;
	lastCompletedBooking: string;
	customerTier: string;
	completedOrders: number;
	qrCode: string;
	ride: Ride;
	send: Send;
	eats: Eats;
	mart: Mart;
};

type Transaction = {
	id: string;
	date: string;
	time: string;
	type: string;
	status: 'Successful' | 'Failed';
	value: number;
};

type Order = {
	id: string;
	date: string;
	time: string;
	type: string;
	source: string;
	status: 'Completed' | 'Cancelled';
	value: number;
};

type OrderHistory = {
	orders: Order[];
};

type Finance = {
	transactions: Transaction[];
};

// type Employee = {
// 	name: string;
// 	phone: string;
// 	email: string;
// 	employeeID: string;
// 	gender: string;
// 	loginMethod: string;
// 	city: string;
// 	inviteCode: string;
// 	role: string;
// 	group: string;
// 	program: string;
// 	createdAt: string;
// 	lastActive: string;
// 	insights: Insights;
// 	finance: Finance;
// 	orderHistory: OrderHistory;
// };

const ViewPeopleScreen = () => {
	const { id } = useParams<{ id: string }>();
	const navigate1 = useNavigate();
	const isManagerOrAdmin = useAuthenticationStore((state) => state.hasRoles)([X4bUserRoleEnum.Manager, X4bUserRoleEnum.Admin]);

	const employeeQ = useQuery({
		queryKey: ['People.Details'],
		queryFn: async () => {
			const result = await axiosInstance.post<GenericResponse<X4bEmployeeDetailsDto>>(ENDPOINTS['/api/X4bEmployee/GetEmployeeDetails'], { Id: id });
			return result.data.Data;
		},
		enabled: !!id
	});


	useEffect(() => {
		if (id) {
			//TODO: handle data
			console.log(`Employee details for id = ${id}`);
		}
	}, [id]);

	// should be after all hooks
	if (employeeQ.isPending) {
		return (<>Loading...</>);
	}

	const navigate = () => {
		navigate1(-1);
	};


	const handleDeletePeople = async () => {
		const employeeName = `${employeeQ.data?.FirstName} ${employeeQ.data?.LastName}`;

		await NiceModal.show(ConfirmModal, {
			title: `Delete ${employeeName}?`,
			message: 'Are you sure you want to delete this employee? This action cannot be undone.',
			acceptLabel: 'Delete',
			rejectLabel: 'Cancel',
			onAccept: async () => {
				await axiosInstance.post<BaseResponse>(ENDPOINTS['/api/X4bEmployee/DeleteEmployees'], [id]);
				navigate();
				showNotification(`${employeeName} has been deleted.`);
			}
		})
	}

	return (
		<div className="flex font-poppins pb-5">
			<div className="grid grid-cols-12 gap-6 w-full">
				{/* Employee Details */}
				<div className="col-span-full md:col-span-4 tablet:!col-span-full">
					<div className={style.employeeInfoContainer}>
						{/* Header */}
						<div className="flex items-center gap-3 mb-4">
							<IconButton
								id="back-btn"
								icon={
									<MdArrowBack
										size={24}
										className="text-primary mr-2"
									/>
								}
								label="Back"
								className={style.employeeBackButton}
								onClick={navigate}
							/>
						</div>

						<EmployeeDetails employeeQ={employeeQ} />
						{isManagerOrAdmin &&
							<div className={style.employeeRemoveContainer}>
								<CustomButton
									id="delete-people"
									className={style.employeeRemoveButton}
									rounded
									onClick={handleDeletePeople}
								>
									Remove Employee
								</CustomButton>
							</div>}
					</div>
				</div>

				{/* Tabs Section */}
				<div className="col-span-full md:col-span-8 tablet:!col-span-full p-4 bg-white rounded-xl">
					<EmployeeActivities employee={employeeQ.data!} />
				</div>
			</div>
		</div>
	);
};

export default ViewPeopleScreen;
